import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ToggleButton from '../../../../ToggleButton';
import { IconSize } from '../../../../Icons/IconWrap';
import { ActionBarDialogContext } from '../../../ActionBarContext';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import ActionBarItemLabel from '../ActionBarItemLabel';
import s from './ActionBarPanelToggle.scss';
/**
 * Provides our `ToggleButton` with some additional ActionBar specific styling.
 * It also lets a user supply a `label`.
 */
var ActionBarPanelToggle = function (_a) {
    var className = _a.className, activated = _a.activated, children = _a.children, label = _a.label, Icon = _a.icon, rest = __rest(_a, ["className", "activated", "children", "label", "icon"]);
    var isMobile = useContext(MobileContext);
    var isAnyDialogOpen = useContext(ActionBarDialogContext);
    return (React.createElement(ToggleButton, __assign({ className: c(s['root'], isAnyDialogOpen && !activated && !isMobile && s['deemphasized'], className), icon: function (props) { return (React.createElement(React.Fragment, null,
            React.createElement(ActionBarItemContentWrapper, null,
                React.createElement(Icon, __assign({}, props))),
            label && (React.createElement(ActionBarItemLabel, { className: s['label'] }, label)))); }, iconSize: IconSize.MEDIUM, activated: activated }, rest)));
};
ActionBarPanelToggle.displayName = 'ActionBarPanelToggle';
export default ActionBarPanelToggle;
//# sourceMappingURL=ActionBarPanelToggle.js.map